// ===== frontend/src/components/Upload/RecommendedForms.jsx (Updated with session storage) =====
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadRecommendedForm } from '../../utils/api';

const RecommendedForms = () => {
  const [isLoading, setIsLoading] = useState(null);
  const navigate = useNavigate();

  const recommendedForms = [
        {
      id: 'wohnberechtigungsbescheinung',
      title: 'Certificate of eligibility for housing',
      description: 'If you are looking for a subsidized apartment (social housing) and have a low income, you can apply for a Wohnberechtigungsschein (WBS).',
      category: 'Housing',
      popular: true
    },
    {
      id: 'city_registration',
      title: 'City Registration',
      description: 'Register with the city of Düsseldorf',
      category: 'Authorities',
      popular: true
    },
    {
      id: 'wohnungsgeber_bestaetigung',
      title: 'Landlord Confirmation',
      description: 'Confirmation from the landlord for authorities',
      category: 'Housing'
    },
    {
      id: 'vollmacht',
      title: 'Power of Attorney',
      description: 'General power of attorney for various purposes',
      category: 'Legal'
    }
  ];

  const handleFormSelect = async (formId) => {
    setIsLoading(formId);
    
    try {
      console.log('Loading recommended form:', formId);
      const result = await loadRecommendedForm(formId);
      console.log('Form loaded successfully:', result);
      
      // Store form structure in localStorage for the session
      localStorage.setItem(`form_structure_${result.sessionId}`, JSON.stringify(result));
      localStorage.setItem(`form_data_${result.sessionId}`, JSON.stringify({}));
      
      navigate(`/form/${result.sessionId}`);
      
    } catch (error) {
      console.error('Error loading recommended form:', error);
      alert('Error loading form: ' + error.message);
    } finally {
      setIsLoading(null);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '0.5rem' }}>
          Frequently Used Forms
        </h2>
        <p style={{ color: '#6b7280' }}>
          Select a pre-made form or upload your own PDF
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem' }}>
        {recommendedForms.map((form) => (
          <div
            key={form.id}
            style={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '0.5rem',
              padding: '1.5rem',
              cursor: 'pointer',
              transition: 'box-shadow 0.2s',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
            }}
            onClick={() => handleFormSelect(form.id)}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)'}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                  <h3 style={{ fontWeight: '600', color: '#111827', margin: 0 }}>
                    {form.title}
                  </h3>
                  {form.popular && (
                    <span style={{
                      backgroundColor: '#dbeafe',
                      color: '#1e40af',
                      fontSize: '0.75rem',
                      padding: '0.25rem 0.5rem',
                      borderRadius: '9999px'
                    }}>
                      Popular
                    </span>
                  )}
                </div>
                <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
                  {form.description}
                </p>
                <span style={{
                  fontSize: '0.75rem',
                  color: '#6b7280',
                  backgroundColor: '#f3f4f6',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '0.25rem'
                }}>
                  {form.category}
                </span>
              </div>
              
              {isLoading === form.id ? (
                <div style={{
                  width: '1.25rem',
                  height: '1.25rem',
                  border: '2px solid #2563eb',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}></div>
              ) : (
                <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              )}
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '0.875rem', color: '#9ca3af' }}>
          Can’t find your form? Upload your own PDF above.
        </p>
      </div>

      {/* Add CSS for spin animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default RecommendedForms;
